import { Catalgue, CatalogueResponse } from "@/core/domain/Catalogue.interfaces";
import { AxiosInstance } from "axios";

export class CatalogueService {

   private api: AxiosInstance;
    constructor(api: AxiosInstance) {
      this.api = api;
    }

  async getCatalogue(catalogueIds: string[]): Promise<Catalgue[]> {
    try {
      const resp = await this.api.post<CatalogueResponse>(`/api/v1/catalogValue/catalogsIds`, catalogueIds);
      return resp?.data?.data;
    } catch (error: any) {
      console.error('Error al obtener los catalogos', error);
      throw error;
    }
  }
}
